import React from 'react'
import {renderMoney,TimeStream} from "../../utils";


class RefundItemList extends  React.Component{
    renderProductType(product_type) {
        switch (product_type) {
            case 'liveroom_vip':
                return 'VIP会员'
            case 'pay_lecture':
                return '课程标题'
            case 'gift_lecture':
                return '课程赠礼'
            case 'pay_channel':
            case 'pay_operate_channel':
                return '专栏标题'
            case 'gift_channel':
                return '专栏赠礼'
            case 'pay_schedule':
                return '打卡活动'
            case 'pay_channel_groupbuy':
                return '专栏拼团'
            case 'pay_member':
                return '荔枝微课会员'
            case 'pay_channel_member':
                return '会员免费听'
            default:
                return ''
        }
    }

    isShowControlBtn(){
        const {isInRefundWhiteList,isSubManager} = this.props
        if(!isSubManager) return true // 讲师本人
        if(isInRefundWhiteList) return true // 在白名单内
        return false
    }
    render(){
        const {dataList} = this.props;
        
         return (
             <div className="isHasList">
             {dataList.length>0 ?
                 <div className="refund-tabBody" >
                     {dataList.map((v, index) => (
                         <div className="refund-list-panel" key={index}>
                             <div className="refund-list-panel-avatar">
                                 <img src={v.account_info.small_avatar_url} alt=""/>
                             </div>

                             <div className="refund-list-panel-userinfo">
                                 <p className="userName">{v.account_info.nickname}</p>
                                 {['pay_lecture', 'pay_channel', 'pay_operate_channel'].indexOf(v.product_type) > -1 ?
                                     <span className="channel-title">
                                        <i>{this.renderProductType(v.product_type)}</i>
                                        <p>{v.product_info.name}</p>
                                     </span>
                                     :
                                     <span className="channel-title">
                                        <i>标题</i>
                                        <p>{this.renderProductType(v.product_type)}</p>
                                     </span>
                                 }
                                 <span className="refund-reason">
                                    <i>退款原因</i>
                                    <p>{v.refund_reason}</p>
                                </span>
                                {
                                      this.props.type === 'refunded' && (
                                          <div>
                                             <span className="refund-reason">
                                                 <i>备注</i>
                                                 <p>{ v.refund_reason_remark || '无' }</p>
                                             </span>
                                          </div>
                                      )
                                }
                              
                                {
                                    this.props.type === 'refunded' &&
                                    (  <span className="refund-type">
                                    <i>退款类型</i>
                                    <p>{{
                                        normal_refund:'普通退款',
                                        all_refund:'全部退款',
                                        partial_refund:'部分退款',
                                        partial_refund_all_fee: '部分退款（不扣除手续费）',
                                        refund_reject:'拒绝退款'
                                    }[v.refund_type] || '-'}</p>
                                    </span>)
                                }
                              
                                 <span className="refund-money">
                                    <i>金额</i>
                                    <p>{renderMoney(v.refund_type==='all_refund' ? v.fee : (v.partial_refund_fee <= 0 ? v.fee : v.partial_refund_fee))}元</p>
                                </span>
                                {
                                    this.props.type === 'refunded' &&
                                    (
                                        <div>
                                            <div className="splitor"></div>
                                                <span className="refund-operator">
                                                    <i>处理人</i>
                                                    <p>{v.refund_account_name || '-'}{v.refund_account_id && `（${v.refund_account_id}）`}</p>
                                                </span>

                                                <span className="refund-operate-time">
                                                    <i>处理时间</i>
                                                    <p>{v.refund_time === 0 || v.refund_time === undefined
                                                    ? '-'
                                                    : TimeStream(v.refund_time)}</p>
                                            </span>
                                        </div>
                                    )
                                }
                             </div>
                             {this.props.type === 'refunding' &&
                             this.isShowControlBtn() && (
                             <div className="refund-list-panel-operation">
                                 <span className="operation-btn" onClick={ ()=>this.props.openActionSheet(v.id) }>操作</span>
                             </div>)
                             }
                             {this.props.type === 'refunded' &&
                             <div className="refund-list-panel-operation slogan-container">
                                 <img className="slogan"  src={require(`../../images/refund/${v.refund_status==='success'? 'refund-success@3x' : 'reject-refund@3x' }.png`)}/>
                             </div>
                             }
                         </div>
                     ))}
                 </div>
                 :
                 <div className="refund-tabBody" >
                     <img className="ifNoDataimg" src="https://static-1253442168.image.myqcloud.com/picture/5915685_3c997315c2944de062355158910c7f1c.jpg" alt=""/>
                     {this.props.type === 'refunding' && <p className="ifNotips">暂时没有退款申请</p>}
                     {this.props.type === 'refunded' && <p className="ifNotips">暂时没有退款记录</p>}
                 </div>
             }
             </div>
        )
    }
}

export  default RefundItemList


// WEBPACK FOOTER //
// ./src/pages/refund/refundItemList.js